import MCommunitySessionBenifitCard from './MCommunitySessionBenifitCard.vue';

export default MCommunitySessionBenifitCard;
export { MCommunitySessionBenifitCard };
